module.exports = __webpack_public_path__ + "img/zloy.2eb55258.png";